const priceFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/** Format a USD price, e.g. `1299` → `"$1,299.00"`; an unset price (`null`) is `"—"`.
 *  Shared across the product catalog. */
export function formatPrice(value: number | null): string {
  return value == null ? '—' : priceFormatter.format(value);
}

/** Format a duration in months as whole years when divisible, else months
 *  (e.g. `24` → `"2 Years"`, `6` → `"6 Months"`). `0` is `"No warranty"`; an unset
 *  warranty (`null`) is `"—"`, never `"0 Years"` (CR 122166). */
export function formatWarranty(months: number | null): string {
  if (months == null) return '—';
  if (months === 0) return 'No warranty';
  if (months % 12 === 0) {
    const years = months / 12;
    return `${years} Year${years === 1 ? '' : 's'}`;
  }
  return `${months} Month${months === 1 ? '' : 's'}`;
}
